import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const NotificationDropdown = () => {
  const dropdownRef = useRef(null);
  const [notification, setnotification] = useState([]);

  const user_id = localStorage.getItem("user_id");

  const API_URL = "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_notification";

  useEffect(() => {
    if (!user_id) {
      toast.error("notification ID missing");
      return;
    }

    fetchnotification();
  }, [user_id]);

  const fetchnotification = async () => {
  try {
    const response = await axios.post(API_URL, {
      user_id,
      role: "All_User"
    });

    if (response.data.status === "true") {
      setnotification(response.data.data);
    }
  } catch (err) {
    console.error(err);
  }
};


const deleteNotification = async (id) => {
    

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_notification",
        { id }
      );

      if (response.data.status === true || response.data.success === "1") {
        toast.error("Notification deleted successfully!");
        setnotification((prev) => prev.filter((item) => item.id !== id));
      } else {
        toast.error("Failed to delete notification.");
      }
    } catch {
      toast.error("Something went wrong while deleting notification.");
    }
  };


  return (
    <div className="notification-dropdown" ref={dropdownRef}>
      {/* Header */}
      <div className="dropdown-header">
        <span>Notifications</span>
      </div>

      {/* List */}
      <div className="notification-list">
        {notification.length === 0 ? (
          <div className="empty-notification">No Notification</div>
        ) : (
          notification.map((item) => (
            <div
              key={item.id}
              className={`notification-item ${String(item.is_read) === "0" ? "unread" : ""
                }`}
            >
              
              <div className="avatar">
                {item.user_image ? (
                  <img src={item.user_image} alt="" />
                ) : (
                  <span>{item.title?.charAt(0)}</span>
                )}
              </div>

              <div className="contentnoti">
                <p className="text">
                  <strong>{item.title}</strong> {item.message}
                </p>
                <span className="time">{item.created_at}</span>
              </div>
              <button
                        className="delete-btn"
                        onClick={() => deleteNotification(item.id)}
                      >
                        ✕
                      </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationDropdown;
